import { forwardRef } from 'react';
import { useController, useFormContext } from 'react-hook-form';
import {
  AutoComplete,
  ReadOnly,
  useEntityPermission,
  useLocalization,
} from '@ui-framework/index';

const OptionsMultiSelect = forwardRef(({ field, ...props }, ref) => {
  const { control } = useFormContext();
  const { field: input } = useController({
    name: props.name || field.name,
    control,
  });
  const { formatMessage } = useLocalization();
  const { isHidden, isReadOnly } = useEntityPermission();
  const options = (field.options || []).map(option => ({
    ...option,
    label: option.label?.localeId
      ? formatMessage({
          id: option.label.localeId,
          defaultMessage: option.label.defaultMessage,
        })
      : option.label,
  }));
  const selected = (input.value || []).map(
    value =>
      options.find(option => option.value === value) || { value, label: value },
  );
  if (isHidden(props.permission)) return null;
  if (isReadOnly(props.permission, input.value))
    return (
      <ReadOnly name={input.name}>
        {selected.map(option => option.label).join(', ')}
      </ReadOnly>
    );
  return (
    <AutoComplete
      {...input}
      {...props}
      ref={ref}
      control={control}
      isMulti
      defaultOptions={options}
      loadOptions={(search, callback) =>
        callback(
          options.filter(option =>
            option.label.toLowerCase().includes(search.toLowerCase()),
          ),
        )
      }
      overwriteProps={{
        value: selected,
        onChange: optionsValue =>
          input.onChange((optionsValue || []).map(option => option.value)),
      }}
    />
  );
});

export default OptionsMultiSelect;
